"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSSN = exports.validatePhone = exports.validateOTC = exports.validateCurrency = exports.validateCard = void 0;

/**
 * Input validation to be used with \<CardInput />
 *
 * Valid strings:
 * 1234 1234 1234 1234 | 1234123412341234
 *
 * @param {string} value - Value of input
 * @param {function} setValidationState - Setter function for isValid state: `setValidationState(true)` when `value` is a valid string | `setValidationState(false)` when `value` is not a valid string
 */
var validateCard = function validateCard() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var setValidationState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var hasIllegalChars = /[^\d\s]/g.test(value);
  var hasExpectedFormat = /^[0x -9]{4} [0-9]{4} [0-9]{4} [0-9]{1,4}$/g.test(value);
  var hasTrailingWhitespace = /[ \t]+$/g.test(value);
  var showErrorConditions = hasIllegalChars || (value === null || value === void 0 ? void 0 : value.length) > 19 && !hasTrailingWhitespace || (value === null || value === void 0 ? void 0 : value.length) > 16 && !hasExpectedFormat && !hasTrailingWhitespace;
  var hideErrorConditions = (value === null || value === void 0 ? void 0 : value.length) === 0 || !hasIllegalChars;
  if (hideErrorConditions) setValidationState(true);
  if (showErrorConditions) setValidationState(false);
};
/**
 * Input validation to be used with \<CurrencyInput />
 *
 * Valid strings:
 * 123 | 1234 | 123.00 | 1234.00 | 1,234.00 | $123 | .50 | 1.5 | 3.
 *
 * @param {string} value - Value of input
 * @param {function} setValidationState - Setter function for isValid state: `setValidationState(true)` when `value` is a valid string | `setValidationState(false)` when `value` is not a valid string
 */


exports.validateCard = validateCard;

var validateCurrency = function validateCurrency() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var setValidationState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var hasIllegalChars = /[^\d,.$]/g.test(value);
  var hasTooManyCents = /[.]\d{3,}/g.test(value);
  var hasMisplacedComma = /[.]\d*[,]/g.test(value);
  var showErrorConditions = hasIllegalChars || hasTooManyCents || hasMisplacedComma;
  var hideErrorConditions = value.length === 0 || !hasIllegalChars;
  if (hideErrorConditions) setValidationState(true);
  if (showErrorConditions) setValidationState(false);
};
/**
 * Input validation to be used with \<PhoneInput />
 *
 * Valid strings:
 * 1231231234 | 123-123-1234 | 123 123 1234 | 123.123.1234 | (123) 123-1234 | (123)122-1234 | +11231231234 | +1-123-123-1234 | +1-123 123 1234 | +1 (123) 123-1234
 *
 * @param {string} value - Value of input
 * @param {function} setValidationState - Setter function for isValid state: `setValidationState(true)` when `value` is a valid string | `setValidationState(false)` when `value` is not a valid string
 */


exports.validateCurrency = validateCurrency;

var validatePhone = function validatePhone() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var setValidationState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var hasIllegalChars = /[^\d|\s|\-|.|+|(|)]/g.test(value); // 123-123-1234, 123 123 1234, or 123.123.1234

  var basicFormat = /[\d]{3}(\s|-|\.)[\d]{3}(\s|-|\.)[\d]{1,4}/g;
  var hasBasicFormat = basicFormat.test(value); // (123) 123-1234 or (123)-123-1234

  var parensSpaceDashFormat = /\([\d]{3}\)(\s|-)[\d]{3}-[\d]{1,4}/g;
  var hasParensSpaceDashFormat = parensSpaceDashFormat.test(value); // (123)123-1234

  var parensDashFormat = /\([\d]{3}\)[\d]{3}-[\d]{1,4}/g;
  var hasParensDashFormat = parensDashFormat.test(value);
  var unformattedOverLength = value.length > 10 && !hasBasicFormat && !hasParensSpaceDashFormat && !hasParensDashFormat; // true when: "+" or "10000000000"

  var UScountryCode = /(\+|1(?=\d{10}))/g;
  var hasUSCountryCode = UScountryCode.test(value); // true when: "+" precedes any number but 1

  var intlCountryCode = /\+([2-9]|0)/g;
  var hasIntlCountryCode = intlCountryCode.test(value);
  var showErrorConditions = hasIllegalChars || hasBasicFormat && value.length > 12 || hasParensSpaceDashFormat && value.length > 14 || hasParensDashFormat && value.length > 13 || unformattedOverLength && !hasIntlCountryCode;
  var hideErrorConditions = value.length === 0 || !hasIllegalChars || hasUSCountryCode && !hasIllegalChars || hasIntlCountryCode;
  if (hideErrorConditions) setValidationState(true);
  if (showErrorConditions) setValidationState(false);
};
/**
 * Input validation to be used with \<SSNInput />
 *
 * Valid strings:
 * 123121234 | 123-12-1234 | 123 12 1234
 *
 * @param {string} value - Value of input
 * @param {function} setValidationState - Setter function for isValid state: `setValidationState(true)` when `value` is a valid string | `setValidationState(false)` when `value` is not a valid string
 */


exports.validatePhone = validatePhone;

var validateSSN = function validateSSN() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var setValidationState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var hasIllegalChars = /[^\d-\s]/g.test(value); // 123-12-1234 or 123 12 1234

  var basicFormat = /[\d]{3}(\s|-)[\d]{2}(\s|-)[\d]{1,4}/g;
  var hasBasicFormat = basicFormat.test(value);
  var showErrorConditions = hasIllegalChars || hasBasicFormat && value.length > 11 || value.length > 9 && !hasBasicFormat;
  var hideErrorConditions = value.length === 0 || !hasIllegalChars;
  if (hideErrorConditions) setValidationState(true);
  if (showErrorConditions) setValidationState(false);
};
/**
 * Input validation to be used with \<OTCInput />
 *
 * Valid strings:
 * 123456
 *
 * @param {string} value - Value of input
 * @param {function} setValidationState - Setter function for isValid state: `setValidationState(true)` when `value` is a valid string | `setValidationState(false)` when `value` is not a valid string
 */


exports.validateSSN = validateSSN;

var validateOTC = function validateOTC() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var setValidationState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var hasIllegalChars = /[^\d,.$]/g.test(value);
  var hasOnlyNumbers = /[^[0-9]+$]/g.test(value);
  var isGreaterThanSixChars = value.length > 6;
  var showErrorConditions = hasIllegalChars || hasOnlyNumbers || isGreaterThanSixChars;
  var hideErrorConditions = value.length === 0 || !hasIllegalChars;
  if (hideErrorConditions) setValidationState(true);
  if (showErrorConditions) setValidationState(false);
};

exports.validateOTC = validateOTC;